import { ComponentProps, FC } from 'react';
import { useTranslation } from 'react-i18next';

import { COMMUNICATION_PURPOSES } from '@/lib/constants';
import { DropdownPicker } from '../dropdown-picker';

export const DropdownCommunicationPurpose: FC<
  Omit<
    ComponentProps<typeof DropdownPicker>,
    'data' | 'emptyLabel' | 'control' | 'search'
  >
> = (props) => {
  const { t } = useTranslation();

  const purposes = COMMUNICATION_PURPOSES.map((item) => ({
    ...item,
    text: t(`label.communicationPurposes.${item.value}`),
  }));

  return (
    <DropdownPicker
      {...props}
      emptyLabel={t('label.communicationPurpose')}
      data={purposes}
      control="checkbox"
      search
    />
  );
};
